/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {Experiment, Variant} from 'react-optimize'

import {Grid, FormLabel, Typography} from '@material-ui/core'

const styles = theme => ({
    primaryText: {
        color: theme.palette.primaryColor
    },
    accentText: {
        color: '#f50057'
    },
    elementText: {
        marginTop: theme.spacing(4),
        textAlign: 'center!important',
        paddingTop: '9px!important',
        fontSize: '1.4rem!important',
        marginBottom: theme.spacing(0) + 'px!important',
    },
    smallElementText: {
        textAlign: 'left!important',
        paddingTop: '9px!important',
        fontSize: '1.4rem!important',
        marginBottom: '10px!important',
    },
    title: {
        marginBottom: theme.spacing(3),
        marginTop: '0!important',
    },
    description: {
        textAlign: 'center!important',
    },
    legend: {
        padding: '0px 0 0 0!important',
        marginBottom: 6,
        [theme.breakpoints.down(600)]: {
            padding: '14px 0 0 0!important',
        }
    },
    [theme.breakpoints.down(600)]: {
        elementWrapper: {
            padding: '8px 4px 4px 4px!important'
        },
        legend: {
            float: 'left',
            width: 'calc(50% + 8px)'
        },
        title: {
            fontSize: '1.4rem!important',
            marginBottom: theme.spacing(2),
        },
        elementText: {
            marginTop: theme.spacing(2),
            fontSize: '1.2rem!important',
            paddingTop: '4px!important',
            marginBottom: '0!important'
        },
        smallElementText: {
            paddingTop: '4px!important',
            marginBottom: '0!important'
        }
    }
})

class AttentionElement extends PureComponent {
    state = {
        secondsRemaining: null
    }

    componentDidMount() {
        this.startTimer()
    }

    componentWillUnmount() {
        clearInterval(this.timer)
        clearInterval(this.timerShort)
    }

    startTimer() {
        this.setState({
            secondsRemaining: this.props.element.secondsRemaining,
            secondsRemainingShort: 63
        })
        this.timer = setInterval(() => {
            if (this.state.secondsRemaining > 0) {
                this.setState({
                    secondsRemaining: this.state.secondsRemaining - 1
                })
            }
        }, 1000)
        this.timerShort = setInterval(() => {
            if (this.state.secondsRemainingShort > 0) {
                this.setState({
                    secondsRemainingShort: this.state.secondsRemainingShort - 1
                })
            }
        }, 1000)
    }

    getRemainingString = secondsRemaining => {
        if (secondsRemaining === 0) {
            return '0 s'
        }
        const d = Number(secondsRemaining)
        const h = Math.floor(d / 3600)
        const m = Math.floor((d % 3600) / 60)
        const s = Math.floor((d % 3600) % 60)

        const hDisplay = h > 0 ? h + ' h ' : ''
        const mDisplay = m > 0 ? m + ' min ' : ''
        const sDisplay = s > 0 ? s + ' s' : ''
        return hDisplay + mDisplay + sDisplay
    }

    render() {
        const {element, classes} = this.props

        return (
            <Grid item xs={element.xsCols} sm={element.smCols} style={{paddingBottom: 0}} className={classes.elementWrapper + ' attention-element'}>
                {!element.titleSize && (
                    <FormLabel component="legend" className={classes.legend}>
                        {element.title}
                    </FormLabel>
                )}
                {element.titleSize && (
                    <Typography variant={element.titleSize} gutterBottom className={classes.title}>
                        {element.title}
                    </Typography>
                )}
                {element.description && <Typography variant="body1" className={classes.description}>{element.description}</Typography>}
                {element.type === 'timer' && (
                    <Typography
                        variant="h6"
                        id="timer-long"
                        className={
                            (!element.titleSize ? classes.smallElementText : classes.elementText) +
                            ' ' +
                            (this.state.secondsRemaining < element.secondsBoundary ? classes.accentText : classes.primaryText)
                        }
                    >
                        {element.timerPrefix && <span>{element.timerPrefix}</span>} {this.getRemainingString(this.state.secondsRemaining)}
                    </Typography>
                )}
                {element.type === 'timer' && (
                    <Typography
                        variant="h6"
                        style={{display: 'none'}}
                        id="timer-short"
                        className={(!element.titleSize ? classes.smallElementText : classes.elementText) + ' ' + (this.state.secondsRemainingShort < 60 ? classes.accentText : classes.primaryText)}
                    >
                        {element.timerPrefix && <span>{element.timerPrefix}</span>} {this.getRemainingString(this.state.secondsRemainingShort)}
                    </Typography>
                )}
            </Grid>
        )
    }
}

export default withStyles(styles)(AttentionElement)
